import type { IModule, ModuleContext } from '@punica/editor';
import { ModuleLifecycleState } from '@punica/editor';
import { MODULE_NAMES } from '@punica/editor';

/**
 * Shell PanelTabs module.
 * Depends on: kernel.commands
 */
export class PanelTabsModule implements IModule {
  readonly name = MODULE_NAMES.SHELL.PANEL_TABS;
  readonly version = '1.0.0';
  readonly dependencies: readonly string[] = [MODULE_NAMES.KERNEL.COMMANDS];

  #state: ModuleLifecycleState = ModuleLifecycleState.CREATED;

  get state(): ModuleLifecycleState {
    return this.#state;
  }

  async bootstrap(context: ModuleContext): Promise<void> {
    const { punica, registry } = context;

    const commandsState = registry.getState(MODULE_NAMES.KERNEL.COMMANDS);
    if (commandsState !== ModuleLifecycleState.BOOTSTRAPPED) {
      throw new Error(
        'kernel.commands must be bootstrapped before shell.panelTabs'
      );
    }

    // PanelTabs is a direct API instance, not a namespace with manager
    if (!punica.shell?.PanelTabs) {
      throw new Error('PanelTabs API not available');
    }
  }

  async start(context: ModuleContext): Promise<void> {
    // PanelTabs module is ready to use after bootstrap
  }
}
